import { InjectionToken } from '@angular/core';


export const MMU_GOOGLE_TAG_MANAGER_TRACKING_ID = new InjectionToken<string>('Google Tag Manager Tracking Id', {
  providedIn: 'root',
  factory: (): string => 'GTM-KCPZQB4X'
});
